export default (context:any, payload:any) => {
    const moduleId = context.getters.moduleId;
    const targetState = context.rootState[payload.targetId];
    const validity = { ...targetState.validity };

    const hoursId = `${moduleId}_hours`;
    const hoursState = context.rootState[hoursId];
    const hoursDirty = hoursState.flags.dirty;
    const hours = hoursState.value;

    const minutesId = `${moduleId}_minutes`;
    const minutesState = context.rootState[minutesId];
    const minutesDirty = minutesState.flags.dirty;
    const minutes = minutesState.value;

    validity.invalidTime = ((hoursDirty && hours.length) && Number(hours) === 0)
        && ((minutesDirty && minutes.length) && Number(minutes) === 0);
    context.commit('setAttribute', {
        id: payload.targetId,
        attribute: 'validity',
        value: validity,
    }, {
        root: true,
    });

    // Reset invalidTime validation on other time field
    let otherId = hoursId;
    if (payload.targetId.includes('hours')) {
        otherId = minutesId;
    }
    const otherState = context.rootState[otherId];
    const otherValidity = {
        ...otherState.validity,
        invalidTime: false,
    };
    context.commit('setAttribute', {
        id: otherId,
        attribute: 'validity',
        value: otherValidity,
    }, {
        root: true,
    });

    return validity;
};